import './App.css';
import Input from './Components/Input';

function App() {
  return (
    <div>
       <div className='header flex items-center justify-center'>
         <img className='background-size: auto z-0' 
         src='https://images.unsplash.com/photo-1604079628040-94301bb21b91?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1374&q=80' 
         alt=''/>
         <h1 className='text-2x1 text-white mt-10 font-bold uppercase tracking-widest'>TODO</h1>
       </div>
       <Input/>
    </div>
  );
}

export default App;
